import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export type NewsDto = {
  data: Article[]
}

export type Article = {
  id: number
  attributes: {
    title: string
    image: MediaObject
    slug: string
    publicated_at: string
  }
}

export type GetSearchNewsArgs = {
  locale: string
}

export const getSearchNews = async (client: AxiosInstance, { locale }: GetSearchNewsArgs) => {
  const path = `/news`
  const params = {
    locale,
    sort: ['publicated_at:desc'],
    fields: ['title', 'slug', 'publicated_at'],
    populate: {
      image: {
        fields: ['url', 'previewUrl', 'alternativeText', 'caption'],
      },
    },
    // pagination: {
    //   start: 0,
    //   limit: Infinity,
    // },
  }
  return (await client.get<NewsDto>(path, { params })).data.data
}
